import { render, staticRenderFns } from "./MiPerfilComercio.vue?vue&type=template&id=4952be52&scoped=true&"
import script from "./MiPerfilComercio.vue?vue&type=script&lang=js&"
export * from "./MiPerfilComercio.vue?vue&type=script&lang=js&"
import style0 from "./MiPerfilComercio.vue?vue&type=style&index=0&id=4952be52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952be52",
  null
  
)

export default component.exports